// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  firebaseConfig: {
    apiKey: "AIzaSyDLix99asnUvFvsr3qMCeysOGAw9vA2nQk",
    authDomain: "mestors.firebaseapp.com",
    databaseURL: "https://mestors-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "mestors",
    storageBucket: "mestors.appspot.com",
    messagingSenderId: "127541070895",
    appId: "1:127541070895:web:a45de8060a34f66c500ada",
    measurementId: "G-71QKXRPB2B"
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
